import { useMemo } from 'react'
import { Form as FinalForm } from 'react-final-form'
import { Button, Grid, makeStyles } from '@material-ui/core'
import useTranslate from '../../../i18n/useTranslate'
import MyTextfield from '../../../control/textfield/textfield'
import MySelect from '../../../control/select/select'
import { CertificateRequest } from '../../../services/um/useCertificateSummary'

type CertificateSummaryPanelComponentProps = {
    onSubmit: (value: CertificateRequest) => void
    initialValue: CertificateRequest
    onClear: (form: any) => void
}

enum CertificateType {
    COA = 'COA',
    COE = 'COE',
}

const Panel = ({ onSubmit, initialValue, onClear }: CertificateSummaryPanelComponentProps) => {
    const classes = useStyles()
    const translate = useTranslate()
    let defaultTermYear = initialValue.certificateYear ? [initialValue.certificateYear] : undefined
    const currentYear = new Date().getFullYear()

    const closedDueList = useMemo(() => {
        return Array.from({ length: 5 }, (_, i) => {
            const year = currentYear - i
            return {
                value: year,
                label: year + 543,
            }
        })
    }, [translate.languageStore.currentLanguage, currentYear])

    const certificateTypeList = useMemo(() => {
        return [
            { value: CertificateType.COA, label: CertificateType.COA },
            { value: CertificateType.COE, label: CertificateType.COE },
        ]
    }, [translate.languageStore.currentLanguage])

    return (
        <Grid className={classes.root}>
            <FinalForm onSubmit={onSubmit} initialValues={initialValue}>
                {({ handleSubmit, form }) => {
                    return (
                        <Grid container spacing={2} className={classes.container}>
                            <Grid item xs={12} sm={6}>
                                <MySelect
                                    name="certificateYear"
                                    label={translate.get('UM.CERTIFICATE_SUMMARY.SELECT_YEAR.LABEL')}
                                    option={closedDueList}
                                    size="small"
                                    placeholder={translate.get('UM.CERTIFICATE_SUMMARY.SELECT_YEAR.PLACEHOLDER')}
                                    defaultValue={defaultTermYear}
                                />
                            </Grid>

                            <Grid item xs={12} sm={6}>
                                <MySelect
                                    name="certificateType"
                                    label={translate.get('UM.CERTIFICATE_SUMMARY.SELECT_CERTIFICATE_TYPE.LABEL')}
                                    option={certificateTypeList}
                                    size="small"
                                    placeholder={translate.get(
                                        'UM.CERTIFICATE_SUMMARY.SELECT_CERTIFICATE_TYPE.PLACEHOLDER',
                                    )}
                                />
                            </Grid>

                            <Grid item xs={12}>
                                <Grid container justify="flex-end" spacing={2}>
                                    <Grid item>
                                        <Button
                                            size={'large'}
                                            fullWidth
                                            variant="contained"
                                            color="default"
                                            onClick={() => onClear(form)}
                                        >
                                            {translate.get('BUTTON.RESET')}
                                        </Button>
                                    </Grid>
                                    <Grid item>
                                        <Button
                                            size={'large'}
                                            fullWidth
                                            variant="contained"
                                            color="primary"
                                            onClick={handleSubmit}
                                        >
                                            {translate.get('BUTTON.SEARCH')}
                                        </Button>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    )
                }}
            </FinalForm>
        </Grid>
    )
}

const useStyles = makeStyles(() => ({
    container: {
        padding: '1.7rem',
    },
    root: {
        width: '100%',
    },
}))

export default Panel
